<template>
  <div :class="'property-search-page filterDisable'">
    <base-breadcrumb-bar
      :tabItems="tabs"
      :tab.sync="tab"
      :initialTab="tab"
      :pageTitle="'Search properties'"
    >
      <template v-slot:filterBlock>
        <listing-filter
          :defaultFilters="filterState"
          :defaultFilters.sync="filterState"
          :listingFilters.sync="listingOptions"
          :propSearchMode="true"
          :showSlot="tab == 1"
          :showGroupBy="tab == 1 && groupByOwner"
          :currentView="view"
          :areas="areas"
          :areas.sync="areas"
          :sizeType.sync="viewType"
          :clearPickedHQs.sync="pickedHQs"
          :lightstone.sync="lightstone"
        >
          <template v-slot:groupByHq>
            <base-hq-name-picker
              :initial="pickedHQs"
              :chosen-hq-name.sync="pickedHQs"
              clearable
              outlined
              :many="true"
              :yesObject="false"
              :isRequired="false"
            />
          </template>
        </listing-filter>
      </template>
    </base-breadcrumb-bar>
    <div :style="`display:${tab == 0 ? 'block' : 'none'}`">
      <!-- <base-loader-overlay
        :is-loading="loading"
        :step="'map'"
        class="loader-box"
      /> -->
      <google-map
        :initial="propertiesData"
        :passedID="selectedID || mapState.clickedId"
        :maxPropertiesFound="maxPropertiesFound"
        :outerProperty="areas"
        :searchedName="searchedName"
        :propFilters="propertyOptions"
        :lightstone="lightstone"
        :zoom.sync="mapState.zoom"
        :loading.sync="loading"
        :center.sync="newCenter || mapState.center"
        :selectedID.sync="mapState.clickedId"
        :areas.sync="areas"
        :reset="reset"
      >
      </google-map>
    </div>
    <!-- mapState.zoom center -->

    <div v-if="tab == 1">
      <property-grouped-owners
        :propertyIDs="propertyIDFound"
        :propertyCount="maxPropertiesFound"
        :ids="idsFound"
        :counts="maxItemsFound"
        :getAll="getAll"
        :expand="expandGroup"
        :outerDataChange="dataChange"
        :pickedHQs="pickedHQs"
        :viewType="viewType"
        :refreshTable.sync="groupByDatachange"
        :options="
          viewType == 'property'
            ? propertyOptions
            : viewType == 'building'
            ? buildingOptions
            : listingOptions
        "
        v-if="groupByOwner"
      >
        <template v-slot:passedToSearch>
          <div class="for-props leadSwitch longer">
            <span :style="!groupByOwner ? 'opacity: 0.4' : ''">
              Group by Owner HQ</span
            >
            <v-switch v-model="groupByOwner" hide-details color="primary" inset>
            </v-switch>
          </div>
        </template>

        <template v-slot:outerTableFilter>
          <v-btn
            @click="
              expandGroup = expandGroup
                ? null
                : (expandGroup = 'open' + Math.random())
            "
            elevation="0"
            color="#F37168"
            class="ml-2"
          >
            <v-icon>
              {{
                expandGroup ? "mdi-arrow-collapse" : "mdi-arrow-expand"
              }}</v-icon
            >
            {{ expandGroup ? "Collapse" : "Expand" }} All
          </v-btn>
          <div class="filter-table-icon">
            <v-btn outlined elevation="0" color="#F87368">
              <v-icon>mdi-filter-outline</v-icon>
              Customise
            </v-btn>
            <div class="filter-box">
              <v-checkbox
                v-for="(tab, i) in outerHeader"
                :key="i"
                v-if="
                  tab.value != 'data-table-select' &&
                  tab.value != 'actions' &&
                  tab.value != 'deals'
                "
                v-model="tab.selected"
                :label="tab.text"
              ></v-checkbox>
            </div>
          </div>
        </template>
        <template v-slot:listingBuildingTable="{ ids, queryLimit }">
          <property-section
            v-if="viewType == 'property'"
            :propertyOptions="propertyOptions"
            :queryLimit="queryLimit"
            :propertyIDs="ids"
            :outerHeader="outerHeader"
            :outerHeader.sync="outerHeader"
            :hideStats="true"
            :outerDatachange="groupByDatachange"
          />

          <property-building-table
            v-else-if="viewType == 'building'"
            :buildingIDs="ids"
            :queryLimit="queryLimit"
            :buildFilters="buildingOptions"
            :outerHeader="outerHeader"
            :outerHeader.sync="outerHeader"
            :hideStats="true"
            :outerDatachange="groupByDatachange"
          />

          <listing-section
            v-else-if="viewType == 'listing'"
            :listingOptions="listingOptions"
            :queryLimit="queryLimit"
            :listingIDs="ids"
            :outerHeader="outerHeader"
            :outerHeader.sync="outerHeader"
            :hideStats="true"
            :outerDatachange="groupByDatachange"
          />
        </template>
      </property-grouped-owners>

      <div v-else>
        <property-section
          v-if="viewType == 'property'"
          :propertyOptions="propertyOptions"
        >
          <template v-slot:passedToSearch>
            <div class="for-props leadSwitch longer">
              <span :style="!groupByOwner ? 'opacity: 0.4' : ''">
                Group by Owner HQ</span
              >
              <v-switch
                v-model="groupByOwner"
                hide-details
                color="primary"
                inset
              >
              </v-switch>
            </div>
          </template>
        </property-section>

        <property-building-table
          v-else-if="viewType == 'building'"
          :buildFilters="buildingOptions"
        >
          <template v-slot:passedToSearch>
            <div class="for-props leadSwitch longer">
              <span :style="!groupByOwner ? 'opacity: 0.4' : ''">
                Group by Owner HQ</span
              >
              <v-switch
                v-model="groupByOwner"
                hide-details
                color="primary"
                inset
              >
              </v-switch>
            </div> </template
        ></property-building-table>

        <listing-section
          v-else-if="viewType == 'listing'"
          :listingOptions="listingOptions"
        >
          <template v-slot:passedToSearch>
            <div class="for-props leadSwitch longer">
              <span :style="!groupByOwner ? 'opacity: 0.4' : ''">
                Group by Owner HQ</span
              >
              <v-switch
                v-model="groupByOwner"
                hide-details
                color="primary"
                inset
              >
              </v-switch>
            </div>
          </template>
        </listing-section>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleMap from "@/components/Base/Lightstone/GoogleMaps.vue"; //GoogleMaps_new.vue";
import PropertyGroupedOwners from "@/components/Base/Property/PropertyGroupedOwners";

import ListingSection from "@/components/Base/Listings/ListingSection";
import ListingFilter from "@/components/Base/Lightstone/ListingPropertyFilter";
import PropertySearchPicker from "@/components/Base/Lightstone/PropertySearchPicker";
import PropertyBuildingTable from "@/components/Base/Property/PropertyBuildingTable.vue";
import PropertySection from "@/components/Base/Property/PropertySection";

export default {
  components: {
    GoogleMap,
    PropertyGroupedOwners,
    ListingFilter,
    PropertySearchPicker,
    ListingSection,
    PropertyBuildingTable,
    PropertySection,
  },
  props: {
    id: {
      type: [String, Array],
      default: null,
    },
  },
  name: "PropertySearch",
  data() {
    return {
      view: "property",
      listingOptions: {},
      areas: [],

      propertyOptions: {},
      buildingOptions: {},

      propertyIDFound: null,
      maxPropertiesFound: null,
      idsFound: null,
      maxItemsFound: null,

      getAll: true,

      propertiesData: [],

      loading: false,
      selectedID: null,
      newCenter: null,

      tab: 0,
      groupByOwner: false,
      pickedHQs: [],
      searchedName: false,
      dataChange: null,
      groupByDatachange: null,

      viewType: "listing",
      tabs: [
        { text: "Map View", icon: "mdi-earth" },
        { text: `List View`, icon: "mdi-format-list-bulleted" },
      ],
      outerHeader: null,
      expandGroup: 0,

      mapState: {
        center: { lat: -30.5583, lng: 22.9387 },
        zoom: 6,
        clickedId: null,
      },
      tableState: {
        limit: 100,
        page: 1,
        sort: { createdAt: -1 },
        name: "listing",
      },
      filterState: null,
      parentState: { tab: 0, groupBy: false, pickedHQs: [] },
      _hydrating: false,

      lightstone: null,
      reset: null,
    };
  },
  apollo: {},

  methods: {
    applyFromRoute(route) {
      this._hydrating = true;
      const { map, table, filter, parent } = this.$routeState.fromRoute(route);

      if (map) this.mapState = map;
      if (table) this.tableState = table;
      if (filter) this.filterState = filter;
      if (parent) this.parentState = parent;

      this.$nextTick(() => {
        this._hydrating = false;
      });
    },
    syncURL(patchParts) {
      // if (query?.table == "lease") this.viewType = "listing";
      // if (query?.table == "sale") this.viewType = "building";
      // if (query?.tab == "1") this.tab = 1;

      const queryPatch = this.$routeState.buildQuery({
        map: patchParts.map ? patchParts.map : null,
        table: patchParts.table ? patchParts.table : null,
        filter: patchParts.filter ? patchParts.filter : null,
        parent: patchParts.parent ? patchParts.parent : null,
      });
      this.$routeState.patchQuery(this.$router, queryPatch, { replace: true });
    },
    async setSearchRule() {
      this.propertiesData = [];
      this.searchedName = this.listingOptions.searchMode == "text";
      var obj = { ...this.listingOptions };
      this.view = this.tab == 0 ? "property" : this.viewType;

      var response = {};
      var query = {};
      var count = 0;

      if (this.groupByOwner) {
        this.getAll = obj.getAll || Object.keys(obj || {}).length == 0;
        console.log(this.getAll);
        if (this.view == "listing") obj.searchMode = "listing";

        var mode =
          obj.getAll && this.view == "propertyCountTable"
            ? "propertyCountTable"
            : this.view;

        var response = await this.runPropertyFilter(obj, mode);
        this.idsFound = response.ids;
        this.maxItemsFound = response.count;

        this.dataChange = "group" + Math.random();
      }

      if (this.view == "property") {
        if (
          ["text", "property", null].includes(obj.searchMode) ||
          !obj.searchMode
        ) {
          response = await this.runPropertyFilter(obj, "propertyCount");

          query = { ...obj };
          delete query[`getAll`];
          delete query[`searchMode`];
        } else {
          response = await this.runPropertyFilter(obj, "property");
          query = { _id: { $in: response.ids } };
        }
        if (response.property) this.propertiesData = response.property;
        count = response.count;
        this.propertyOptions = query;
        this.maxPropertiesFound = count;
      } else if (this.view == "building") {
        var response = await this.runPropertyFilter(obj, this.view);
        var count = response.count;
        var query = obj.getAll ? {} : { _id: { $in: response.ids } };
        this.buildingOptions = query;
      }
    },
  },
  watch: {
    viewType(newVal) {
      this.outerHeader = null;
      this.setSearchRule();
    },
    listingOptions: {
      async handler(newVal, oldVal) {
        this.setSearchRule();
      },
      deep: true,
    },
    propertyOptions: {
      async handler(newVal, oldVal) {
        if (JSON.stringify(newVal) == '{"isArchived":null}') {
          this.reset = "deed" + Math.random();
        }
      },
      deep: true,
    },
    mapState: {
      async handler(newVal, oldVal) {
        if (this._hydrating) return;
        // this.syncURL({ map: newVal });
      },
      deep: true,
    },
    filterState: {
      async handler(newVal, oldVal) {
        if (this._hydrating) return;
        // this.syncURL({ filter: newVal || {} });
      },
      deep: true,
    },
    parentState: {
      async handler(newVal, oldVal) {
        this.groupByOwner = newVal.groupBy;
        this.tab = newVal.tab;
        this.pickedHQs = newVal.pickedHQs;

        if (this._hydrating) return;
        // this.syncURL({ filter: this.filterState || {} });
        if (!newVal) return;
      },
      deep: true,
    },
    groupByOwner(newVal) {
      this.setSearchRule();
      if (this._hydrating) return;
      // this.parentState.groupBy = !!newVal;
      // this.syncURL({ parent: this.parentState });
    },
    // $route(to, from) {
    //   console.log(to.query);
    //   this.syncURL();
    //   this.applyFromRoute(to);
    // },
    tab(newVal) {
      this.setSearchRule();
      if (newVal == 0) {
        this.viewType = "property";
      }
      if (this._hydrating) return;
      // this.parentState.tab = Number(newVal) || 0;
      // this.syncURL({ parent: this.parentState });
    },
    pickedHQs: {
      async handler(newVal, oldVal) {
        if (this._hydrating) return;
        // this.parentState.pickedHQs = newVal;
        // this.syncURL({ parent: this.parentState });
      },
      deep: true,
    },
  },

  created() {
    // this.syncURL(this.$route.query);
    // this.applyFromRoute(this.$route);
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.property-search-page {
  position: relative;
}

.map-toggle-btn {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 60%;
  opacity: 0.7;
}

.map-toggle-btn:hover {
  opacity: 1;
}

.property-search-page {
  position: relative;
}
// .property-search-page .loader-box {
//   width: 200px !important;
//   height: 200px !important;
//   opacity: 0.8;
//   pointer-events: none;
//   position: absolute;
//   bottom: 10px;
//   left: 50%;
//   top: 40%;
//   border-radius: 50%;
//   border: 2px solid #fff;
// }
</style>
